var WebStorage = /** @class */ (function () {
    function WebStorage(ctx) {
        this.prefix = '_horn_';
        this.ctx = ctx;
    }
    WebStorage.prototype.getWithExpires = function (key) {
        var fullkey = this._getFullKey(key);
        try {
            var originValue = localStorage.getItem(fullkey);
            if (!originValue) {
                return Promise.resolve(null);
            }
            return Promise.resolve(JSON.parse(originValue));
        }
        catch (error) {
            if (this.ctx.ignoreStorageError) {
                console.warn('[Horn] 获取 localStorage 失败 :', error);
                return Promise.resolve(null);
            }
            else {
                console.error('[Horn] 获取 localStorage 失败 :', error);
                this.remove(key);
                return Promise.reject(error);
            }
        }
    };
    WebStorage.prototype.set = function (key, value, expires) {
        if (expires === void 0) { expires = 0; }
        var fullKey = this._getFullKey(key);
        var rawValue = {
            expireTime: expires,
            originValue: value,
        };
        try {
            localStorage.setItem(fullKey, JSON.stringify(rawValue));
            return Promise.resolve();
        }
        catch (error) {
            if (this.ctx.ignoreStorageError) {
                console.warn('[Horn] set localStorage 失败 :', error);
                return Promise.resolve();
            }
            else {
                console.error('[Horn] set localStorage 失败 :', error);
                return Promise.reject(error);
            }
        }
    };
    WebStorage.prototype.remove = function (key) {
        var fullKey = this._getFullKey(key);
        try {
            localStorage.removeItem(fullKey);
            return Promise.resolve();
        }
        catch (err) {
            // 存储失败
            console.error("[Horn] \u6E05\u9664 localStorage \u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5", err);
            return Promise.reject(err);
        }
    };
    // /**
    //  * 判断对应key 是否在 localStorage 中存在
    //  */
    // has(key: string) {
    //   const fullKey = this._getFullKey(key);
    //   const result = localStorage.getItem(fullKey);
    //   return result ? true : false;
    // }
    WebStorage.prototype._getFullKey = function (key) {
        return "" + this.prefix + key;
    };
    return WebStorage;
}());
export default WebStorage;
//# sourceMappingURL=web-storage.js.map